import styled from 'styled-components'
import { ScoreDisplay } from '../atoms/ScoreDisplay/ScoreDisplay'
import { media } from '../../utils/mediaQuery'
import { SectionColorKey } from '../molecules/AnalysisSidebar/AnalysisSidebar.types'

const sectionIconColors: Record<SectionColorKey, string> = {
  steel: '#64748B',
  bronze: '#92400E',
  forest: '#166534',
  deepBlue: '#1E3A8A',
  wine: '#9F1239',
}

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 16px 12px 16px;
  gap: 12px;

  ${media.tabletDown} {
    flex-direction: column;
    padding: 8px 16px 6px 16px;
    gap: 8px;
  }
`

export const HeaderContent = styled.div`
  flex: 1;
  min-width: 0; /* Prevent content from overflowing */
  display: flex;
  align-items: flex-start;
  gap: 10px;
`

export const TitleIconPill = styled.span<{ $sectionColor?: SectionColorKey }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  background: ${({ theme, $sectionColor }) =>
    $sectionColor ? theme.colors.tags[$sectionColor] : theme.colors.tags.gray};
  color: ${({ $sectionColor }) =>
    $sectionColor ? sectionIconColors[$sectionColor] : '#6B7280'};

  ${media.tabletDown} {
    display: none;
  }
`

export const TitleTextWrapper = styled.div`
  flex: 1;
  min-width: 0;
`

export const PageTitle = styled.h1<{ $sectionColor?: SectionColorKey }>`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme, $sectionColor }) =>
    $sectionColor
      ? sectionIconColors[$sectionColor]
      : theme.colors.text.primary};
  margin: 0 0 4px 0;
  letter-spacing: -0.5px;

  ${media.tabletDown} {
    font-size: 14px;
    margin: 0;
  }
`

export const PageSubtitle = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;

  ${media.tabletDown} {
    display: none;
  }
`

export const ScoreDisplayWrapper = styled(ScoreDisplay)`
  && {
    background: ${({ theme }) => theme.colors.background.primary};
    border: 1px solid ${({ theme }) => theme.colors.border.light};
    border-radius: 12px;
    padding: 12px 20px;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    flex-shrink: 0;
  }

  ${media.tabletDown} {
    && {
      width: 100%;
      padding: 8px 12px;
      border-radius: 8px;
    }
  }
`
